import {css} from '@emotion/css';
import {createSignal, Show} from 'solid-js';
import { useUrls } from 'Shared/SiteProvider';
import { CallCropper, handleFile, IImageUpload, uploadImage } from 'Shared/forms/ImageUpload';
import { useStore } from 'Shared/StoreProvider';
import { reconcile } from 'solid-js/store';
import * as ImageSizes from 'Shared/model/ImageSizes';


const dndStyle = (draggingOver:boolean) => css({
	cursor: 'pointer',
	...(draggingOver ? { backgroundColor: '#00000010' } : {})
});


//FIXME cursor pointer should probably only appear when over buttons or image. Otherwise allow all of it to be clickable.

export function ImageUploadDragAndDrop(P:IImageUpload)
{
	const sw = useStore();
	const urls = useUrls();
	const uploadUrl = () => urls.uploadImageUrl(sw,P.folder,P.dimensions);
	const crop = () => ImageSizes[P.dimensions].ratio != undefined;

	/*
		NOTE dragenter doesn't seem very reliable when it comes to maintaining an overlay effect so 
		     using dragover instead.
	*/
	const [draggingOver,setDraggingOver] = createSignal(false);
	const leaveZone = (e:DragEvent) => { e.preventDefault(); e.stopPropagation(); setDraggingOver(false); };

	const [croppingFile,setCroppingFile] = createSignal();

	const setImage = value => sw.setStore(...sw.location,reconcile(value));

	/*
		WARNING - DnD files from Ubuntu file manager is buggy.
		For Chrome it works about 1 time in 20.
		FF is more reliable, but still goes on the blink.
			https://askubuntu.com/questions/1421539/drag-and-drop-of-files-not-working-on-version-22-04
			https://www.reddit.com/r/Ubuntu/comments/v19mkm/is_drag_and_drop_broken_for_anyone_else_on_2204/
		For comparison, check the DnD library demos which don't work either, eg
			https://www.dropzone.dev/
			https://uppy.io/examples/
		NB Chrome-to-Chrome copying seems mostly OK.
	*/
	const handleDrop = async (e:DragEvent) => {
		e.preventDefault();
		setDraggingOver(false);
		await handleFile(e.dataTransfer?.files,null,crop(),setCroppingFile,setImage,uploadUrl())
	};

	/* 
		Enable the zone for dropping.
		It is possible to check the type and disable the zone if its wrong, or if there are multiple items.
		So far doesn't seem reliable. 
		ALSO behaviour may be better without it: dropping a file on a disabled zone takes you to a new browser page.
	*/
	const defineZone = (e:DragEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setDraggingOver(true);
	};

	const cropDone = blob => uploadImage(blob,uploadUrl(),setImage,setCroppingFile,undefined);

	return (<>
		<div class={dndStyle(draggingOver())} 
			on:dragover={defineZone}
			on:dragleave={leaveZone}
			onDrop={handleDrop}
		>
			{P.children}
		</div>

		<Show when={croppingFile()}>
			<CallCropper dimensions={P.dimensions} file={croppingFile()} setShowCrop={setCroppingFile} done={cropDone} />
		</Show>
	</>);
}

